import styled from 'styled-components';

const ModalContent = styled.p`
  width: 412px;
  ${({ theme }) => theme.typograph.paragraphRegular}

`;

export {
  ModalContent,
};
